import {RouterProvider, createRouter} from '@tanstack/react-router';
import {routeTree} from './routeTree.gen.ts';

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  basepath: import.meta.env.VITE_ROUTER_PATH,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export const App: React.FC = () => <RouterProvider router={router} />;
